<template>
  <div
    v-if="periodSelectionOption"
    class="tw-flex tw-items-center tw-pb-3 tw-gap-3"
  >
    <span class="tw-p-2 tw-bg-sf-slate-subtle-2 tw-rounded">
      <img
        v-tooltip.html.placementBottom="
          I18n.t(periodSelectionOption.tooltipKey)
        "
        :src="$imagesRequire(iconPath)"
        data-tooltip-size="sm"
      />
    </span>

    <span v-dompurify-html="title" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { SfTime } from '@app/adapters/time'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { periodSelectionOptions } from '../constants'
import { periodSelectionCategories } from '../types'
import { useInsightsRootStore } from '../store/insights-root'
import { usePeriodSelectionTrigger } from '../composables/use-period-selection-trigger'
import { isLockType, lockTypeLabel } from '../utils/lock-type-label'

const I18n = useI18n()
const rootStore = useInsightsRootStore()
const periodSelection = computed(() => rootStore.periodSelection)
const ledgerSelectDate = computed(() => rootStore.ledgerSelectDate)
const ledgerSelectLockType = computed(() => rootStore.ledgerSelectLockType)

const today = I18n.t(
  'companies_overview.period_selection_new.date_selection_placeholder_with_date',
  { date: SfTime(new Date()).format('DD/MM/YYYY') }
)
const periodSelectionOption = computed(() =>
  periodSelectionOptions.find((option) => option.key === periodSelection.value)
)

const iconPath = computed(
  () => `insights/${periodSelectionOption.value?.icon}-active.svg`
)

const lockType = computed(() => {
  // active_period/completed_period titles interpolate this; a URL (or old bookmark) can select
  // those periods without a lock type, or with a value that is not one. Guard so the title never
  // renders a "[missing translation]" fragment for that key.
  const option = periodSelectionOption.value
  const storedLockType = ledgerSelectLockType.value
  if (!option || !storedLockType || !isLockType(storedLockType)) return ''

  return lockTypeLabel(option.key, storedLockType)
})

const value = computed(() => {
  if (
    periodSelectionOption.value?.category ===
    periodSelectionCategories.BY_LOCKING_STATE
  ) {
    return lockType.value
  }
  return ledgerSelectDate.value || today
})

const { title } = usePeriodSelectionTrigger({
  periodSelectionOption,
  // Unused here: triggerClass only matters for the dropdown triggers'
  // selected-vs-unselected font weight, not this always-selected explainer.
  isParentSelected: true,
  value,
})
</script>
<style scoped lang="scss">
:deep(.dropdown-trigger) {
  font-weight: bold;
}
</style>
